var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{staticStyle:{"margin":"0px","padding":"0px","overflow":"hidden"},attrs:{"fullscreen":"","title":_vm.title,"active":_vm.popupPdfCommon},on:{"update:active":function($event){_vm.popupPdfCommon=$event}}},[_c('img',{staticClass:"w-full",attrs:{"src":_vm.pdfurl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }